//------------------------------------------------------------------------------
// This file is auto-generated.
//------------------------------------------------------------------------------
// This file was generated by NTypewriter from the C# ViewModel class with the
// same class/interface name.
//
// Do not change this file.  Any changes may cause incorrect behaviour and will
// be lost if the code is regenerated.
//------------------------------------------------------------------------------

import { ReportInputItem } from './ReportInputItem';
import { ReportType } from './Enums';

export class InvoiceDetailsReportInputItem extends ReportInputItem {
    InvoiceIDs: string[] = [];
    override readonly Type: ReportType = ReportType.InvoiceDetails;

    constructor(initializer?: Partial<Omit<InvoiceDetailsReportInputItem, "Type">>) {
        super();
        if (initializer) {
            Object.assign(this, initializer);
        }
    }

    static override readonly ClassName: string = "InvoiceDetailsReportInputItem";
}
